/* eslint-disable @typescript-eslint/no-explicit-any, no-magic-numbers */
import { createContext } from 'react';
const EntityFormContext = createContext({
    creating: false,
    entityName: 'DefaultEntity',
    isEditing: false,
    fieldWrapperClassNames: {},
    values: {},
    errors: {},
    touched: {},
    isSubmitting: false,
    isValidating: false,
    submitCount: 0,
    setStatus: createWarn('setStatus'),
    setErrors: createWarn('setErrors'),
    setSubmitting: createWarn('setSubmitting'),
    setTouched: createWarn('setTouched'),
    setValues: createWarn('setValues'),
    setFieldValue: createWarn('setFieldValue'),
    setFieldError: createWarn('setFieldError'),
    setFieldTouched: createWarn('setFieldTouched'),
    validateForm: createWarn('validateForm', Promise.reject().catch(e => e && console.warn(e))),
    validateField: createWarn('validateField'),
    resetForm: createWarn('resetForm'),
    submitForm: createWarn('submitForm', Promise.reject().catch(e => e && console.warn(e))),
    setFormikState: createWarn('setFormikState'),
    handleSubmit: createWarn('handleSubmit'),
    handleReset: createWarn('handleReset'),
    handleBlur: createWarn('handleBlur'),
    handleChange: createWarn('handleChange'),
    getFieldProps: createWarn('getFieldProps'),
    getFieldMeta: createWarn('getFieldMeta'),
    getFieldHelpers: createWarn('getFieldHelpers'),
    dirty: false,
    isValid: false,
    isNew: true,
    initialValues: {},
    initialErrors: {},
    initialTouched: {},
    registerField: createWarn('registerField'),
    unregisterField: createWarn('unregisterField'),
});
function createWarn(name, result = undefined) {
    return (...args) => {
        console.warn(`"${name}" not provided`, ...args);
        return result;
    };
}
export default EntityFormContext;
